class SliderMinProduct {
    constructor(product, options = {}){
        this.options = Object.assign(
            {},
            {    
                
            }, 
            options 
        );    

        this.product = product; 
        this.leftControl = product.querySelector(".content-medias .left");
        this.rightControl = product.querySelector(".content-medias .right");

        //Slider
        this.slides = product.querySelectorAll(".content-medias .medias .media");
        this.nbSlides = product.querySelectorAll(".content-medias .medias .media").length - 1 + 2; // +2 clones to infinite
        this.currentSlide = 1; // 0 + 1 clone 
        this.isSliding = false;

        this.firstSlide = this.slides[0].cloneNode(true);
        this.lastSlide = this.slides[this.slides.length - 1].cloneNode(true);

        product.querySelector(".content-medias .medias").prepend(this.lastSlide);
        product.querySelector(".content-medias .medias").append(this.firstSlide); 
        
        this.product.addEventListener("click", () => {
            if(this.isMobile){
                window.location.href = this.product.getAttribute("data-product-url");
            }
        });

        //Gestion slider
        this.leftControl.addEventListener("click", () => {
            if(!this.isSliding && !this.isMobile){
                this.currentSlide -= 1;
                if(this.currentSlide < 0){
                    this.currentSlide = 0;
                }
                this.goTo(this.currentSlide);
            }
        });
        this.rightControl.addEventListener("click", () => {
            if(!this.isSliding && !this.isMobile){
                this.currentSlide++;
                if(this.currentSlide > this.nbSlides){ 
                    this.currentSlide = this.nbSlides; 
                } 
                this.goTo(this.currentSlide);
            }
        });

        this.product.querySelector(".content-medias .medias").addEventListener("transitionend", (event) => {
            if(event.propertyName == "transform" && !this.isMobile){
                this.isSliding = false;
                if(this.currentSlide == 0){
                    this.product.querySelector(".content-medias .medias").style.transition = "transform 0s ease";
                    this.product.querySelector(".content-medias .medias").style.WebkitTransition = "transform 0s ease";
                    let translate = -this.slideWidth * (this.nbSlides - 1) + 'px'; 
                    this.currentSlide = this.nbSlides - 1;
                    this.product.querySelector(".content-medias .medias").style.transform = `translateX(${translate})`;  
                }
                if(this.currentSlide == this.nbSlides){
                    this.product.querySelector(".content-medias .medias").style.transition = "transform 0s ease";
                    this.product.querySelector(".content-medias .medias").style.WebkitTransition = "transform 0s ease";
                    let translate = -this.slideWidth * 1 + 'px'; 
                    this.currentSlide = 1;
                    this.product.querySelector(".content-medias .medias").style.transform = `translateX(${translate})`;  
                }
            } 
        });

        window.addEventListener("resize", (event) => {  
            this.product.querySelector(".content-medias .medias").style.transition = "transform 0s ease";
            this.product.querySelector(".content-medias .medias").style.WebkitTransition = "transform 0s ease";
            let translate = -this.slideWidth * this.currentSlide + 'px';  
            this.product.querySelector(".content-medias .medias").style.transform = `translateX(${translate})`; 
        });
    } 

    goTo(index){ 
        this.isSliding = true; 
        let translate = -this.slideWidth * index + 'px'; 
        this.product.querySelector(".content-medias .medias").style.transition = "transform 0.3s ease";
        this.product.querySelector(".content-medias .medias").style.WebkitTransition = "transform 0.3s ease";
        this.product.querySelector(".content-medias .medias").style.transform = `translateX(${translate})`; 
    }

    majBullets(index){
        this.product.querySelector(".content-bullets .bullet.active").classList.remove("active");
        this.product.querySelector(`.content-bullets .bullet[data-index="${index}"]`).classList.add("active");
    }

    get slideWidth(){ 
        return this.product.querySelector(".content-medias").getBoundingClientRect().width;
    }

    get isMobile(){
        return window.innerWidth < 992 ? true : false;
    }
}